export var FeatureType = /*#__PURE__*/function (FeatureType) {
  FeatureType["Permanent"] = "permanent";
  FeatureType["Dynamic"] = "dynamic";
  FeatureType["OptIn"] = "optIn";
  return FeatureType;
}(FeatureType || {});
export var OptInFeatureScope = /*#__PURE__*/function (OptInFeatureScope) {
  OptInFeatureScope["User"] = "user";
  OptInFeatureScope["Company"] = "company";
  return OptInFeatureScope;
}(OptInFeatureScope || {});
export var OptInFeatureManager = /*#__PURE__*/function (OptInFeatureManager) {
  OptInFeatureManager["Admin"] = "admin";
  OptInFeatureManager["Self"] = "self";
  return OptInFeatureManager;
}(OptInFeatureManager || {});